import { render, staticRenderFns } from "./select-users.vue?vue&type=template&id=4a51d865&scoped=true&"
import script from "./select-users.vue?vue&type=script&lang=js&"
export * from "./select-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a51d865",
  null
  
)

export default component.exports